import React from 'react';
import { Package, Users, HardDrive } from '@phosphor-icons/react';
import { formatMB } from '../../../shared/utils/fileFormat.js';
import StorageBreakdownBar from './StorageBreakdownBar.jsx';
import PlanStorageWarningBanner from './PlanStorageWarningBanner.jsx';

const MyPlanSummaryCard = ({ plan, technicianCount, storage }) => (
  <div className="bg-surface rounded-xl shadow-lg border border-line p-6">
    <div className="flex items-center justify-between flex-wrap gap-3 pb-6 border-b border-line">
      <div className="flex items-center gap-3">
        <Package size={24} className="text-content-muted" />
        <h2 className="text-xl font-semibold text-content">{plan.name}</h2>
      </div>
      <span
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium border ${
          plan.isActive
            ? 'bg-success/12 text-success border-success'
            : 'bg-muted-deep/12 text-muted-deep border-muted-deep'
        }`}
      >
        <span className={`w-1.5 h-1.5 rounded-full ${plan.isActive ? 'bg-success' : 'bg-muted-deep'}`} />
        {plan.isActive ? 'Activo' : 'Inactivo'}
      </span>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-surface-2 shrink-0">
          <Users size={18} className="text-content-muted" />
        </div>
        <div>
          <p className="text-xs text-content-muted">Usuarios técnicos</p>
          <p className="text-base font-semibold text-content mt-0.5">{technicianCount} de {plan.maxUsers}</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-surface-2 shrink-0">
          <HardDrive size={18} className="text-content-muted" />
        </div>
        <div>
          <p className="text-xs text-content-muted">Almacenamiento</p>
          <p className="text-base font-semibold text-content mt-0.5">
            {formatMB(storage.used)} de {formatMB(storage.limit)}
          </p>
        </div>
      </div>
    </div>

    <StorageBreakdownBar storage={storage} />
    <PlanStorageWarningBanner storage={storage} />
  </div>
);

export default MyPlanSummaryCard;
